import React from 'react';
import PropTypes from 'prop-types';

const Settlements = ({ altText }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' fill='none'>
      <title id='settlements-title'>{altText}</title>
      <path fill='currentColor' d='M11 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z' />
      <path fill='currentColor' fillRule='evenodd' d='M11.335.33a.75.75 0 0 0-.67 0l-10 5A.75.75 0 0 0 .25 6v3c0 .414.336.75.75.75h1.25v5.514a2.25 2.25 0 0 0-2 2.236V19c0 .414.336.75.75.75h20a.75.75 0 0 0 .75-.75v-1.5a2.25 2.25 0 0 0-2-2.236V9.75H21a.75.75 0 0 0 .75-.75V6a.75.75 0 0 0-.415-.67l-10-5ZM3.75 15.25v-5.5h2.5v5.5h-2.5Zm6.5-5.5h-2.5v5.5h2.5v-5.5Zm1.5 0v5.5h2.5v-5.5h-2.5Zm6.5 5.5h-2.5v-5.5h2.5v5.5Zm-16.5-7V6.464L11 1.839l9.25 4.625V8.25H1.75Zm0 9.25a.75.75 0 0 1 .75-.75h17a.75.75 0 0 1 .75.75v.75H1.75v-.75Z' clipRule='evenodd' />
    </svg>
  );
};

Settlements.propTypes = {
  altText: PropTypes.string
};

export default Settlements;
